import { BoundProxy, bindProxy } from "@excitare/cli-proxy";
import { DefaultPathSymbol } from "@excitare/cli-types";

import { LocalService } from "./local/service";
import { localServices } from "./local/services";

export class Proxy {
  constructor(private readonly port: number, private readonly services: LocalService[]) {}

  currentProxy: BoundProxy | null = null;

  async listen() {
    if (this.currentProxy != null) {
      await this.currentProxy.close();
      this.currentProxy = null;
    }

    const deployableServices = this.services.filter(el => el.service.publicFacingPath != null);

    const proxyEndpoints = deployableServices.map(el => {
      if (el.service.publicFacingPath === DefaultPathSymbol) {
        return {
          dest: `${el.currentData.host}`
        };
      }
      return {
        pathname: el.service.publicFacingPath,
        dest: `${el.currentData.host}`
      };
    });

    this.currentProxy = await bindProxy(proxyEndpoints, this.port);
    for (const localService of deployableServices) {
      localServices.updateServiceData(
        localService.currentData.name,
        {
          publicFacingUrl: `http://localhost:${this.port}`
        },
        true
      );
    }
  }

  close() {
    if (this.currentProxy != null) {
      this.currentProxy.close().catch(err => console.error(err));
    }
  }
}
